import { useRouter } from '#imports'
import { isMobile } from '@/utils/systemInfo'

export default function useGoMobile() {
  const router = useRouter()
  isMobile() && router.push('/mobile')
}
